const CONTRACT_STATE_LABEL = {
    proposal: 'návrh',
    valid: 'platná',
    postponed: 'odložená',
    finished: 'ukončená',
    valid_unsigned: 'platná, nepodepsaná',
    proposal_esign: 'odesláno k elektronickému podpisu',
}

export default CONTRACT_STATE_LABEL